import React from 'react';

const CouponCodeFormikContext = React.createContext();

export default CouponCodeFormikContext;
